export default "__VITE_ASSET__Ciw3gqJc__"